enum Routes {
    Login = '/login',
    Dashboard = '/',
    Publishers = '/publishers',
    PublishersNew = '/publishers/new',
    PublishersView = '/publishers/:id',
    PublishersEdit = '/publishers/:id/edit',
    Subscribers = '/subscribers',
    SubscribersNew = '/subscribers/new',
    SubscribersView = '/subscribers/:id',
    SubscribersEdit = '/subscribers/:id/edit',
    Mappers = '/mappers',
    MappersNew = '/mappers/new',
    MappersView = '/mappers/:id',
    MappersEdit = '/mappers/:id/edit',
    History = '/history',
}

export default Routes;
